import { isNullOrUndefined } from 'util';

export class StringUtils {

    public static NOT_AVALIABLE = "";

    public static default(word: string): string {
        if (isNullOrUndefined(word) || word === '') return StringUtils.NOT_AVALIABLE
        return word;
    }

    public static valueOrDefault(value: string, defaultValue: string): string {
        if (isNullOrUndefined(value) || value === '') return defaultValue
        return value;
    }
}
